<template>
  <v-row>
    <v-col>
      <participant v-if="!loggedIn && showEmailField" ref="participant" :participantTypes="participantTypes" :evenName="evenName" :preview="true"
        :editEmailPreview="showEmailField"></participant>
      <v-row v-if="!loggedIn">
        <v-col>
          <h2 style="text-align: center;">
            {{ $t('previewRegisterText') }}
            <span><u>{{ $t(evenName) }}</u></span>
          </h2>
        </v-col>
      </v-row>
      <v-card class="mb-2" v-if="loggedIn && (payments && payments.length)">
        <v-card-title>
        </v-card-title>
        <v-card-text >
          <v-row v-if="payments && payments.length">
            <v-col>
              <v-expansion-panels v-model="expanded">
              <v-expansion-panel expand v-model="expanded">
                <v-expansion-panel-header>
                  {{ $t("payments") }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table :headers="$t('previewHeaderPayments')" :items="payments" :items-per-page="5"
                      disable-sort disable-filtering disable-pagination :hide-default-footer="true">
                      <template v-slot:item.date="{ item }">
                        {{ formatPlaymentDate(item.date) }}
                      </template>
                      <template v-slot:item.ammount="{ item }">
                        {{ item.ammount }} {{ $t(currency) }}
                      </template>
                      <template v-slot:item.type="{ item }">
                        {{ formatPlaymentType(item.type) }}
                      </template>
                      <template v-slot:item.status="{ item }">
                        <v-chip :color="getPlaymentStatusColor(item.status)" dark>
                          {{ formatPlaymentStatus(item.status) }}
                        </v-chip>
                      </template>
                    </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        <v-row v-if="totalPayed>0">
          <v-col>
              <div class="payed paymentDesc">
                {{
                $t("acceptedPaymentsTotal")
              }}
                : {{ totalPayed }} {{ $t(currency) }}
                
              </div>
          </v-col>
        </v-row>
      </v-card-text>
      </v-card>
      <v-form ref="form" v-model="validForm" class="px-1">
    <template v-if="justRegistered">
      <v-row >
        <v-col>
          <v-alert type="success" prominent text dismissible><b>{{ $t('participantSuccesRegistered', {eventName:evenName}) }}</b></v-alert>
        </v-col>
      </v-row>
    </template>
    <v-row v-if="totalRemaining>0||!loggedIn">
      <v-col></v-col>
    </v-row>
    <v-container fluid>
          <v-row>
            <v-col v-if="theSum>0" cols="12" sm="6" class="text-center">
              <!-- Content for the first column -->
              <div>
                <v-btn color="primary" @click="onFinalizeClicked(loggedIn ? undefined: 'ONLINE')" :disabled="!validForm || (theSum<=0 && loggedIn)">
                        {{ $t(paymentRegistrationButtonLabel) }} {{ theSum>0?theSum:"" }} {{ theSum>0? $t(serverData.currency):"" }}
                      </v-btn>
              </div>
            </v-col>
            <v-col  v-if="!loggedIn"  cols="12" sm="6" class="text-center">
              <!-- Content for the second column -->
              <div>
                <v-btn color="primary" @click="onFinalizeClicked('LATER')">
                        {{ totalToPay > 0 ? $t("finishRegister") : $t('finishRegisterNoPay') }}
                      </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
    <template v-if="anythingToPay">
      <v-row v-if="totalRemaining>0 && this.loggedIn">
        <v-col>
          <v-select v-model="paymentMethod" :items="paymentTypes" :label="$t('paymentMethod')" item-text="text" item-value="value" required />
        </v-col>
        <v-col v-if="paymentMethod!='LATER'">
          <v-text-field :disabled="true" v-model="theSum" :label="$t('amount')" :suffix="$t(serverData.currency)"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="paymentMethod=='BANK'">
        <v-col>
          <span>{{ $t('bankProofFileMessage') }}</span>
                <v-file-input :label="$t('bankProofFileMessage')" v-model="modelPayment.bankProof" @change="upload(modelPayment.bankProof)" :rules="[required]"
                accept="application/pdf, image/*" :max-size="3000000"></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card v-if="paymentMethod=='BANK'">
            <v-card-title>{{ $t("Date bancare") }}</v-card-title>
            <v-card-text>
              <div v-html="$t(serverData.bankTransfer)"></div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <template>
        <v-row v-if="message">
          <v-col>
            <div class="title">
              {{ $t(message) }}
            </div>
            <div class="title" v-if="totalRemaining>0">
              {{ $t(paymentText) }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="title">
              {{ $t('paymentText') }}
            </div>
            <div v-if="totalRemaining>0">
              {{ $t('paymentTextDesc') }}
            </div>
          </v-col>
        </v-row>
            <v-card class="mb-2" v-if="unifiedServices && unifiedServices.length > 0">
              <v-card-title class="title">
                {{ $t("paymentTaxAndServices") }} : {{ totalServicesAndTax }} {{ $t(currency) }}
              </v-card-title>
              <v-card-text>
                <v-data-table :headers="computedServicesHeaders" v-model="checkedServices" :items="unifiedServices"
                  :items-per-page="5" disable-sort disable-filtering disable-pagination :hide-default-footer="true"
                  :show-select="this.paymentMethod!='LATER'"
                  @toggle-select-all="selectAllToggleServices">
                  <template v-slot:item.price="{ item }">
                    {{ item.price }} {{ $t(currency) }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getTableStatusColor(checkedServices,item)" dark v-if="paymentMethod!='LATER' && item.price>0">
                      {{$t( getTableStatusDesc(checkedServices,item)) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.data-table-select="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="!item.disabled && paymentMethod!='LATER'"
                      :value="isSelected"
                      @input="select($event)"
                      :ripple="false"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card class="mb-2" v-if="unifiedRooms && unifiedRooms.length">
              <v-card-title class="title">
                {{ $t("stepTitles.hotel") }} : {{ roomsPrice }}
                {{ $t(currency) }}
              </v-card-title>
              <v-card-text>
                <v-data-table :headers="$t('previewHeaderRoom')" v-model="checkedRooms" :items="unifiedRooms"
                  :items-per-page="5" disable-sort disable-filtering disable-pagination
                  :hide-default-footer="true" :show-select="this.paymentMethod!='LATER'"
                  @toggle-select-all="selectAllToggleRooms">
                  <template v-slot:item.price="{ item }">
                    {{ item.price }} {{ $t(currency) }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getTableStatusColor(checkedRooms,item)" dark v-if="paymentMethod!='LATER'">
                      {{$t( getTableStatusDesc(checkedRooms,item)) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.data-table-select="{ item, isSelected, select }">
                    <v-simple-checkbox v-if="!item.disabled && paymentMethod!='LATER'"
                      :value="isSelected"
                      @input="select($event)"
                      :ripple="false"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <!--
        <v-checkbox class="px-2" v-if="modelPayment.paymentMethod == 'BANK'" v-model="modelPayment.paymentDone"
          :label="$t('Plata prin transfer bacar efectuata')"></v-checkbox>
          -->
          <v-card class="mb-2" v-if="loggedIn && (totalRemaining >0 || (payments && payments.length))">
              <v-card-title>
              </v-card-title>
              <v-card-text >
              <v-row v-if="totalPayed>0">
                <v-col>
                    <div class="payed paymentDesc">
                      {{
                      $t("acceptedPaymentsTotal")
                    }}
                      : {{ totalPayed }} {{ $t(currency) }}
                      
                    </div>
                </v-col>
              </v-row>
              <v-row v-if="totalPending>0">
                <v-col>
                    <div class="processingPayed paymentDesc">
                      {{
                      $t("processingPaymentsTotal")
                    }}
                      : {{ totalPending }} {{ $t(currency) }}
                      
                    </div>
                </v-col>
              </v-row>
              <v-row v-if="totalRemaining>0">
                <v-col>
                    <div class="notPayed paymentDesc">
                      {{
                      loggedIn ? $t("previewToRemainingPay") : $t("previewToPay")
                    }}
                      : {{ totalRemaining }} {{ $t(currency) }}
                      
                    </div>
                </v-col>
              </v-row>
              <v-row v-if="totalRemaining<=0">
                  <v-col>
                    <template>
                    <div class="payed paymentDesc">
                      {{ $t('allPaymentsDone') }}
                    </div>
                  </template>
                  </v-col>
              </v-row>
            </v-card-text>
          </v-card>  
        <template v-if="totalRemaining>0">  
          <v-checkbox class="px-2" v-if="paymentMethod!='LATER'" v-model="modelPayment.addCompanyData"
            :label="$t('taxAmountCompanyBill')"></v-checkbox>
          <v-jsf v-if="modelPayment.addCompanyData" v-model="modelPayment.companyData"
            :schema="companyDataSchema">
          </v-jsf>
        </template>
        <v-container fluid>
          <v-row>
            <v-col v-if="theSum>0" cols="12" sm="6" class="text-center">
              <!-- Content for the first column -->
              <div>
                <v-btn color="primary" @click="onFinalizeClicked(loggedIn ? undefined: 'ONLINE')" :disabled="!validForm || (theSum<=0 && loggedIn)">
                        {{ $t(paymentRegistrationButtonLabel) }} {{ theSum>0?theSum:"" }} {{ theSum>0? $t(serverData.currency):"" }}
                      </v-btn>
              </div>
            </v-col>
            <v-col  v-if="!loggedIn"  cols="12" sm="6" class="text-center">
              <!-- Content for the second column -->
              <div>
                <v-btn color="primary" @click="onFinalizeClicked('LATER')">
                        {{ totalToPay > 0 ? $t("finishRegister") : $t('finishRegisterNoPay') }}
                      </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </template>
    <template v-if="!anythingToPay">
      {{ $t('nothingToPay') }}
    </template>
  </v-form>
    </v-col>
  </v-row>
</template>
      
<script>
import { participant } from "@/model/participant";
import Participant from "./Participant.vue";
import moment from "moment";
import Vue from "vue";
import { isPaymentAccepted,isPaymentPending} from "@/utils/utils.js";
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";
import { getRoomPayment, getServicePayment, getTaxPayment } from "../utils/utils";
export default {
  components: { Participant,VJsf },
  props: {
    participantTypes: {
      type: Array,
      required: true,
    },
    evenName: {
      type: String,
      required: true,
    },
    eventTax: {
      type: Object,
      required: true,
    },
    requiredServices: {
      type: Array,
      required: true,
    },
    optionalServices: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    hotels: {
      type: Array,
      required: true,
    },
    payments: {
      type: Array,
      required: true,
    },
    loggedIn: {
      type: Boolean,
      required: true,
    },
    showEmailField: {
      type: Boolean,
      required: false,
    },
    modelPayment: {
      type: Object,
      required: true,
    },
    serverData: {
      type: Object,
      required: true,
    },
    companyDataSchema: {
      type: Object,
      required: true,
    },
    justRegistered: {
      type: Boolean, 
      required: false
    },
  },
  data() {
    return {
      validForm: false,
      participant,
      expanded: 0,
      checkedServices: [],
      checkedRooms: [],
      paymentMethod : "ONLINE",
      theTax : undefined,
      extendedSelectedRooms : [],
      unifiedServices : [],
      unifiedRooms : [],
      eventParticipationTax : undefined,
      taxPrice : 0 ,
      taxPriceSponsored : 0 ,
      servicesPrice : 0,
      servicePriceSponsored : 0,
      totalServicesAndTax : 0,
      roomsPrice : 0 ,
      roomsPriceSponsored : 0 ,
      totalSponsored : 0,
      totalToPay : 0,
      totalPayed : 0,
      totalRemaining : 0,
    };
  },
  watch: {
    modelPayment: function () {
      //this.saveToLocalStorage("modelPayment");
    },
    checkedServices : function (newVal) {
      if(newVal.find(x=>x.id=="eventTax")){
        this.modelPayment.payedTax = true;
      }else{
        this.modelPayment.payedTax = false;
      }
      this.modelPayment.checkedServices=newVal;
    },
    checkedRooms : function (newVal) {
      this.modelPayment.checkedRooms = newVal;
    },
    validForm: function (newVal) {
      this.$emit("formValid", newVal);
    },
    paymentMethod : function(newVal) {
      this.modelPayment.paymentMethod = newVal;
      if(newVal=='LATER'){
        this.uncheckAll();
      }else if(newVal == 'ONLINE'){
        this.checkAllUnpaid();
      }else if(newVal == 'BANK'){
        if(this.$refs.form){
          setTimeout(() => this.$refs.form.validate(), 100);
        }
      }
    },
    "modelPayment.addCompanyData":function(newVal){

      if(newVal){
        if(this.$refs.form){
          setTimeout(() => this.$refs.form.validate(), 100);
        }
      }
    }
  },
  computed: {

    paymentTypes : function(){
      const allowed = [
        { key: '0', value: 'ONLINE', text: this.$t('onlinePayment') }
      ];
      if(!this.loggedIn){
        allowed.push({ key: '2', value: 'LATER', text: this.$t('payLater') })
      }
      else{
        allowed.push({ key: '1', value: 'BANK', text: this.$t('bankTransfer') })
      }
      return allowed;
    },

    paymentRegistrationButtonLabel : function(){
    if(this.theSum<=0 && !this.loggedIn){
      return "finishRegister";
    }
    if(this.paymentMethod == 'ONLINE'){
        if(this.loggedIn){
            return "previewPay"
        }else{
          return "payOnlineAndFinishRegister";
        }
      }
      else{
        if(this.loggedIn){
            return "previewPayBank"
        }else{
          return "payBankAndFinishRegister";
        }
      }
    },
    computedServicesHeaders () {
      return this.$t('taxServicesHeaders').filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide]);
    },
    anythingToPay : function  (){
      return this.unifiedServices.length>0 || this.unifiedRooms.length > 0;
    },
    message: {
      get: function () {
        if (this.paymentMethod == 0) {
          this.checkAllUnpaid();
          return "wantToPayWithCard";
        } else if (this.paymentMethod == 1) {
          this.uncheckAll();
          return "payedWithBankTransfer";
        } else if (this.paymentMethod == 2) {
          this.uncheckAll();
          return "wantToPayLater";
        }
        return undefined;
      },
      set: function (newVal) {
        return newVal;
      },
    },
    theSum: {
      get: function () {
        if(this.paymentMethod=='LATER'){
          return 0;
        }
        let sum = 0;
        if (this.checkedServices && this.checkedServices.length > 0) {
          this.checkedServices.forEach((service) => {
            sum += service.price;
          });
        }
        if (this.checkedRooms && this.checkedRooms.length > 0) {
          this.checkedRooms.forEach((room) => {
            sum += room.price;
          });
        }
        Vue.set(this.modelPayment, "ammount", sum);
        return this.modelPayment.ammount;
      },
      set: function (newVal) {
        Vue.set(this.modelPayment, "ammount", newVal);
        return this.modelPayment.ammount;
      },
    },
    currParticipationType: function () {
      return this.participant.services.participationType;
    },
    totalPending: function () {
      let totalProcessing = 0;
      if (this.payments) {
        this.payments.forEach((payment) => {
          if (isPaymentPending(payment)) {
            totalProcessing = totalProcessing + payment.ammount;
          }
        });
      }
      return totalProcessing;
    },
  },
  methods: {
    
    required: function (value) {
      if (value) {
        return true;
      } else {
        return this.$t("error.required");
      }
    },
    upload(file){
      if(file) {
        var reader = new FileReader();
        reader.onloadend = ()=> {
          Vue.set(this.modelPayment.bankProof, 'data', reader.result.split(',')[1])
        }
        reader.readAsDataURL(file);
      }else{
        this.modelPayment.bankProof.data = undefined;
      }
    },
     selectAllToggleServices(props) {
       if(props.value) {
         this.checkedServices = [];
         const self = this;
         props.items.forEach(item => {
           if(!item.disabled) {
             self.checkedServices.push(item);
           } 
         });
       } else this.checkedServices = [];
     },
     selectAllToggleRooms(props) {
       if(props.value) {
         this.checkedRooms = [];
         const self = this;
         props.items.forEach(item => {
           if(!item.disabled) {
             self.checkedRooms.push(item);
           } 
         });
       } else this.checkedRooms = [];
     },
    selectedRoomIndex: function (roomId) {
      for (var i = 0; i < this.participant.rooms.selectedRooms.length; i++) {
        if (this.participant.rooms.selectedRooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    oneRoomPrice: function (roomId) {
      let totalPrice = 0;
      this.hotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          if (room.id === roomId) {
            let selectedIdx = this.selectedRoomIndex(room.id);
            if (selectedIdx >= 0) {
              let selectedDates =
                this.participant.rooms.selectedRooms[selectedIdx].dates;
              if (selectedDates) {
                if (selectedDates.length > 0) {
                  let startDate = moment(selectedDates[0], "YYYY-MM-DD");
                  let endDate = startDate;
                  if (selectedDates.length > 1) {
                    endDate = moment(selectedDates[1], "YYYY-MM-DD");
                  }
                  let nights = Math.abs(endDate.diff(startDate, "days"));
                  totalPrice = totalPrice + nights * room.price;
                } else {
                  let nights = 1;
                  totalPrice = totalPrice + nights * room.price;
                }
              }
            }
          }
        });
      });
      return totalPrice;
    },
    onPayment: function () {
      // TODO: Remove the items that were payed if payment successfull
      this.unifiedServices.forEach((service, index) => {
        this.checkedServices.forEach((checked) => {
          if (checked.id == service.id) {
            this.unifiedServices.splice(index, 1);
          }
        });
      });
    },
    checkAllUnpaid: function () {
      this.selectAllToggleServices({value:true,items:this.unifiedServices});
      this.selectAllToggleRooms({value:true,items:this.unifiedRooms});
    },
    uncheckAll: function () {
      this.checkedServices = [];
      this.checkedRooms = [];
    },
    onFinalizeClicked: function (payMethod) {
      if(payMethod){
        this.paymentMethod = payMethod;
        this.modelPayment.paymentMethod = payMethod;
      }
      this.$emit('onfinaliseclicked');
    },
    formatPlaymentDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm");
    },
    formatPlaymentType(type) {
      switch (type) {
        case "CARD":
          return "Card Online";
        case "BANK":
          return "Transfer bancar";
        default:
          return "";
      }
    },
    getTableStatusColor(selectedArray, item) {
      if(item.price<=0){
        return ;
      }
      //item selected for payment
      if(item.sponsored || item.payed){
        return "green";
      }
      if(selectedArray.find(x=>x.id == item.id)){
        return "orange";
      }

      if(!item.payed){
        return "red";
      }

    },
    getTableStatusDesc(selectedArray, item) {
      if(item.price<=0){
        return "";
      }
      //item selected for payment
      if(item.payed){
        return "payPagePayed";
      }
      if(item.sponsored){
        return "payPageSponsored";
      }
      if(selectedArray.includes(item)>0){
        return "payPageToPay";
      }
      if(!item.payed){
        return "payPageNotPayed";
      }

    },
    getPlaymentStatusColor(status) {
      switch (status) {
        case "APPROVED":
          return "green";
        // TODO: 'case' with 'return' values needs to be switched
        case "REJECTED":
        case "CANCELED":
          return "red";
        default:
          return "orange";
      }
    },
    formatPlaymentStatus(status) {
      return this.$t(status);
    },
  },
  mounted() { 
    this.paymentMethod = 'ONLINE';
    this.modelPayment.paymentMethod = this.paymentMethod;
    this.modelPayment.payedTax = false;
    if (
      this.eventTax &&
      this.eventTax.taxAmounts &&
      this.currParticipationType
    ) {
      if (this.eventTax.taxAmounts && this.eventTax.taxAmounts.length > 0) {
        const tax = this.eventTax.taxAmounts.find(
          (element) => element.attendanceType.id == this.currParticipationType
        );
        this.eventParticipationTax = tax;
      }
    }

    if (this.eventTax) {
      const taxPayment = getTaxPayment(this.participant, true);
      let payed = taxPayment!=undefined;
      let sponsored = this.participant.services.sponsored;
      if(!payed){
        const price = this.eventParticipationTax.amount;
        this.taxPrice = price;
      }else{
        this.taxPrice = taxPayment.payedEventTax[0].ammount;
      }
      
      if(sponsored){
        this.taxPriceSponsored = this.taxPrice;
      }
      this.theTax = {
        name: this.$t("taxDescription"),
        key: this.$t("taxDescription"),
        description:
          this.$t("payed") +
          " - " +
          this.eventParticipationTax?.attendanceType.name,
        price: this.taxPrice,
        disabled :  payed || sponsored ||this.taxPrice<=0,
        payed : payed,
        sponsored:sponsored,
        id:"eventTax"
      };
    }
    this.extendedSelectedRooms = [];
    
    this.hotels.forEach((hotel) => {
      hotel.rooms.forEach((room) => {
        for (var i = 0; i < this.participant.rooms.selectedRooms.length; i++) {
        if (this.participant.rooms.selectedRooms[i].roomId === room.id) {
          let selectedDates =
          this.participant.rooms.selectedRooms[i].dates;
          let interval = "";
          if (selectedDates && selectedDates.length > 0) {
            let startDate = moment(selectedDates[0], "YYYY-MM-DD");
            let endDate = startDate;
            interval = selectedDates[0];
            if (selectedDates.length > 1) {
              endDate = moment(selectedDates[1], "YYYY-MM-DD");
              interval = interval + " - " + selectedDates[1];
            }
            let nights = Math.abs(endDate.diff(startDate, "days"));
            const price = nights * room.price;
            const sponsored = this.participant.rooms.selectedRooms[i].sponsored;
            this.extendedSelectedRooms.push({
              hotel: hotel.name,
              room: room.name,
              roomId : room.id,
              interval: interval,
              nights: nights,
              price: price,
              reservationId : this.participant.rooms.selectedRooms[i].roomReservationId,
              sponsored : sponsored
            });
          }   
        }
      }
      });
    });

    this.unifiedServices = [];
    if (this.theTax) {
      this.unifiedServices.push(this.theTax);
    }

    this.requiredServices.forEach(service=>{
      let servicePayment = getServicePayment(this.participant, service.id, true);
      let payed = servicePayment!=undefined;
      let sponsored = false;//this.participant.services.sponsored;
      service.payed=payed;
      if(payed){
        service.price = servicePayment.ammount;
      }
      service.sponsored=sponsored;
      service.disabled=sponsored||payed||service.price<=0;
      this.servicesPrice+=service.price;
      if(sponsored){
        this.servicePriceSponsored+=service.price;
      }
      this.unifiedServices.push(service);
      
    });
    this.optionalServices.forEach((optService) => {
      this.participant.services.selectedServices.forEach((selServiceId) => {
        if (optService.id == selServiceId.serviceId ) {
          let servicePayment = getServicePayment(this.participant, selServiceId.serviceId, true);
          let payed = servicePayment!=undefined;
          let sponsored = selServiceId.sponsored;//this.participant.services.sponsored;
          optService.payed=payed;
          if(payed){
            optService.price = servicePayment.ammount;
          }
          optService.sponsored=sponsored;
          optService.disabled=sponsored||payed||optService.price<=0;
          this.servicesPrice+=optService.price;
          if(sponsored){
            this.servicePriceSponsored+=optService.price;
          }
          this.unifiedServices.push(optService);
        }
      });
    });

    this.unifiedRooms = [];
  
    this.extendedSelectedRooms.forEach(selectedRoom=>{
      const roomPayment = getRoomPayment(this.participant,selectedRoom.reservationId, true);
      selectedRoom.payed = roomPayment!=undefined;
      selectedRoom.id = JSON.stringify(selectedRoom);
      selectedRoom.disabled = selectedRoom.payed || selectedRoom.sponsored||selectedRoom.price<=0;
      selectedRoom.price = roomPayment ? roomPayment.ammount : selectedRoom.price;
      selectedRoom.payment = roomPayment;
      this.roomsPrice +=selectedRoom.price;
      if(selectedRoom.sponsored){
        this.roomsPriceSponsored+=selectedRoom.price;
      }
      
      this.unifiedRooms.push(selectedRoom);
      
    });

    this.totalPayed = 0;
    if (this.payments) {
      this.payments.forEach((payment) => {
        if (isPaymentAccepted(payment)) {
          this.totalPayed = this.totalPayed + payment.ammount;
        }
      });
    }

    this.totalServicesAndTax = this.taxPrice + this.servicesPrice;
    this.totalSponsored = this.taxPriceSponsored + this.servicePriceSponsored + this.roomsPriceSponsored;
    
    this.totalToPay = this.totalServicesAndTax + this.roomsPrice - this.totalSponsored;
    this.totalRemaining = this.totalToPay-this.totalPayed;
    this.checkAllUnpaid();
  },
  created() { },
};
</script>
<style scoped lang="css">
.truncated-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden; 
  width: 100px;
}

.paymentDesc {
  display: flex;
  height: 3em;
  /* text-align: center; */
  align-items: center;
  justify-content: center;
}
.payed {
  background: #2fb74652;
  color: green;
}

.notPayed {
  background: #ff000021;
  color: red;
}

.processingPayed {
  background: #ff980038;
  color: #ff9800;
}
</style>